import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { ChannelService } from '@app/core/channels/services/channel.service';

@Component({
  selector: 'filter-channels',
  templateUrl: './filter-channels.component.html',
  styleUrls: ['./filter-channels.component.scss'],
})
export class FilterChannelsComponent implements OnInit, OnDestroy {
  constructor(
    public channelSvc :ChannelService,
    private cd :ChangeDetectorRef,
  ) {}

  @Input() value :number[] | string | number;
  @Input() label :string;
  @Input() usedFrom :string;
  @Input() options ?:{ multi ?:boolean } = { multi: true };
  @Output() changeChannels :EventEmitter<number[] | number | string> =
    new EventEmitter<number[]>();

  public _channels = this.channelSvc.channels$;
  public channels :any[] = [];
  private channelObs :Subscription;

  ngOnInit() :void {
    this.channelSvc.get({ all: 1 });
    this.channelObs = this.channelSvc.channels$.subscribe((res) => {
      this.channels = res.data;
      if (res.data) {
        this.channels.splice(
          0,
          0,
          { id: -1, label: 'Luminous Invoices' },
          { id: -2, label: 'Luminous Transfer Orders' },
        );
        if (typeof this.value === 'string') {
          // If value is a string, split it and convert each part to a number
          this.value = this.value.split(',').map(Number);
        } else if (this.usedFrom === 'purgatory' && Array.isArray(this.value)) {
          this.value = this.value[0];
        }
      }
      this.cd.detectChanges();
    });
  }

  ngOnDestroy() {
    this.channelObs.unsubscribe();
  }

  onChange() {
    this.changeChannels.emit(this.value);
  }
}
